
import OParam from './OParam';

export default class OInput extends OParam {
  constructor (ghInputParam) {
    super();
    this.ghInputParam = ghInputParam;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/OInput.js